window.isSafari = function () {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('safari') && !ua.includes('chrome') && !ua.includes('android');
};
class Guide {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }

  event(){
    const slides = document.querySelectorAll('.c-swiper-guide .swiper-slide');
    if (slides.length > 1) {
      swiper = new Swiper('.c-swiper-guide', {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: '.c-swiper-guide-nav',
          clickable: true,
        },
      });
    }
  }
}

class Interview {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector("." + this.el)) {
      this.event();
    }
  }

  event() {
    (() => {
      const swiperEl = document.querySelector(".js-swiper-interview");
      if (!swiperEl) return;

      const slides = swiperEl.querySelectorAll(".swiper-slide");
      const slideCount = slides.length;

      var interviewSwiper = new Swiper(".js-swiper-interview", {
        slidesPerView: 1.5,
        centeredSlides: true,
        loop: true,
        spaceBetween: 16,
        speed: 1000,
        autoplay: {
          delay: 1000,
          disableOnInteraction: true
        },
        breakpoints: {
          768: {
            slidesPerView: 3.7,
            spaceBetween: 40,
            centeredSlides: false,
          }
        },
        pagination: {
          el: ".js-swiper-interview-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".js-swiper-interview-next",
          prevEl: ".js-swiper-interview-prev",
        },
      });

      document.querySelector(".js-swiper-interview-stop").addEventListener("click", function () {
        interviewSwiper.autoplay.stop();
      });

      // const mql = window.matchMedia("(min-width: 768px)");

      // let interviewSwiper = null;

      // const initSwiper = (isPC) => {
      //   return new Swiper(".js-swiper-interview", {
      //     slidesPerView: 1.5,
      //     centeredSlides: true,
      //     loop: true,
      //     spaceBetween: 16,
      //     speed: 2000,
      //     autoplay: {
      //       delay: 1000,
      //       disableOnInteraction: true,
      //     },
      //     pagination: {
      //       el: ".js-swiper-interview-pagination",
      //       clickable: true,
      //     },
      //     navigation: {
      //       nextEl: ".js-swiper-interview-next",
      //       prevEl: ".js-swiper-interview-prev",
      //     },
      //     breakpoints: {
      //       768: {
      //         slidesPerView: 3.7,
      //         spaceBetween: 40,
      //       },
      //     },
      //   });
      // };

      // const checkAndInitSwiper = () => {
      //   const isPC = mql.matches;

      //   const shouldDisable =
      //     (isPC && slideCount < 4) || (!isPC && slideCount < 2);

      //   if (interviewSwiper) {
      //     interviewSwiper.destroy(true, true);
      //     interviewSwiper = null;
      //     swiperEl.classList.remove("is-swiper-enabled");
      //   }

      //   if (!shouldDisable) {
      //     interviewSwiper = initSwiper(isPC);
      //     swiperEl.classList.add("is-swiper-enabled");
      //     swiperEl.classList.remove("is-static");
      //   } else {
      //     swiperEl.classList.add("is-static");
      //   }
      // };

      // checkAndInitSwiper();

      // mql.addEventListener("change", checkAndInitSwiper);

      // const stopBtn = document.querySelector(".js-swiper-interview-stop");
      // if (stopBtn) {
      //   stopBtn.addEventListener("click", () => {
      //     if (interviewSwiper && interviewSwiper.autoplay) {
      //       interviewSwiper.autoplay.stop();
      //     }
      //   });
      // }
    })();
  }
}

class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){ 
    const isSp = window.matchMedia('(max-width: 767px)').matches;

    if (!isSp) {
      let isLocked = false;
    
      // 初期表示
      $(`.js-project-area[data-project="1"]`).css({
        opacity: '1',
        visibility: 'visible',
        'pointer-events': 'auto'
      });
    
      function showProject(id) {
        $('.js-project-area').css({
          opacity: '0',
          visibility: 'hidden',
          'pointer-events': 'none'
        });
    
        $(`.js-project-area[data-project="${id}"]`).css({
          opacity: '1',
          visibility: 'visible',
          'pointer-events': 'auto'
        });
      }
    
      // hover：ロックされていないときだけ
      $('.ic-balloon').on('mouseenter', function () {
        if (isLocked) return;
    
        const id = $(this).data('project');
        showProject(id);
      });
    
      // click：表示固定 + is-active 管理
      $('.ic-balloon').on('click', function () {
        const id = $(this).data('project');
    
        isLocked = true;
    
        // is-active を付け替え
        $('.ic-balloon').removeClass('is-active');
        $(this).addClass('is-active');
    
        showProject(id);
      });
    } else {
      document.querySelectorAll('.s-project .ic-balloon').forEach((balloon, i) => {
        const style = window.getComputedStyle(balloon);
        const matrix = new DOMMatrixReadOnly(style.transform);
      
        const baseX = matrix.m41; // X の translate 値
        const baseY = matrix.m42; // Y の translate 値（基本0）
      
        balloon.animate(
          [
            { transform: `translate(${baseX}px, ${baseY}px)` },
            { transform: `translate(${baseX}px, ${baseY - 12}px)` },
            { transform: `translate(${baseX}px, ${baseY}px)` }
          ],
          {
            duration: 3000 + (i * 500),
            iterations: Infinity,
            easing: 'ease-in-out',
            delay: -(i * 400)
          }
        );
      });
      
      // $('.project-slide').hide();

      // const modal = $(`
      //   <div class="js-project-modal">
      //     <div class="inner">
      //       <div class="swiper js-project-swiper">
      //         <div class="swiper-wrapper"></div>
      //       </div>
      //       <div class="controller">
      //         <div class="js-swiper-project-prev">
      //           <svg viewBox="0 0 11 14"><path d="M0 7L10.5 0.937823V13.0622L0 7Z" fill="#222"/></svg>
      //         </div>
      //         <div class="js-swiper-project-close">
      //           <svg viewBox="0 0 23 23"><rect x="15.9659" y="5.35938" width="2.36842" height="15" transform="rotate(45 15.9659 5.35938)" fill="#222"/><rect x="17.6406" y="15.9663" width="2.36842" height="15" transform="rotate(135 17.6406 15.9663)" fill="#222"/></svg>
      //         </div>
      //         <div class="js-swiper-project-next">
      //           <svg viewBox="0 0 11 14"><path d="M11 7L0.5 0.937823V13.0622L11 7Z" fill="#222"/></svg>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // `);
      
      // $('body').append(modal);

      const wrapper = $('.js-project-modal .swiper-wrapper');

      // $('.project-slide').each(function () {
      //   $(this)
      //     .addClass('swiper-slide')
      //     .appendTo(wrapper);
      // });

      const projectSwiper = new Swiper('.js-project-swiper', {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 20,
        loop: true,
        speed: 0,
        navigation: {
          nextEl: '.js-swiper-project-next',
          prevEl: '.js-swiper-project-prev',
        },
      });      

      const open = (index) => {
        $('.js-project-modal').addClass('is-active');
        projectSwiper.slideToLoop(index, 0, false);
        $('html,body').css('overflow', 'hidden');
      };
      
      const close = () => {
        $('.js-project-modal').removeClass('is-active');
        $('html,body').css('overflow', '');
      };

      $(document).on('click', '.js-swiper-project-close', close);

      $('.js-project-modal').on('click', function (e) {
        if (e.target === this) close();
      });      

      $(document).on('click', '.ic-balloon', function () {
        const projectId = String($(this).data('project'));
      
        const realSlides = projectSwiper.slides.filter(
          slide => !slide.classList.contains('swiper-slide-duplicate')
        );
      
        const index = realSlides.findIndex(
          slide => slide.dataset.project === projectId
        );
      
        if (index === -1) return;
      
        $('.js-project-modal').addClass('is-active');
        $('html,body').css('overflow', 'hidden');
      
        projectSwiper.slideToLoop(index, 0, false);
      });     
      
    }

    var peopleSwiper = new Swiper(".js-swiper-people", {
      slidesPerView: 1.5,
      centeredSlides: true,
      loop: true,
      spaceBetween: 16,
      speed: 2000,
      autoplay: {
        delay: 1000,
        disableOnInteraction: true
      },
      breakpoints: {
        768: {
          slidesPerView: 3.7,
          spaceBetween: 40,
        }
      },
      pagination: {
        el: ".js-swiper-people-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".js-swiper-people-next",
        prevEl: ".js-swiper-people-prev",
      },
    });

    document.querySelector(".js-swiper-people-stop").addEventListener("click", function () {
      peopleSwiper.autoplay.stop();
    });

    // var mvSwiper = new Swiper(".js-mv-swiper", {
    //   slidesPerView: 1,
    //   loop: true,
    //   speed: 2000,
    //   autoplay: {
    //     delay: 5000,
    //     disableOnInteraction: false,
    //   },
    // });

    const slides = document.querySelectorAll(".mv-slide");
    let current = 0;
    let isAnimating = false;
    
    function nextSlide() {
      if (isAnimating) return;
      isAnimating = true;
    
      const prev = slides[current];
      const nextIndex = (current + 1) % slides.length;
      const next = slides[nextIndex];
      crossTransition(prev, next, nextIndex === 0);
      current = nextIndex;
    }
    
    function crossTransition(prev, next, isLoopToFirst = false) {
      const prevImg = prev.querySelector("img");
      const nextImg = next.querySelector("img");
    
      slides.forEach((s) => gsap.set(s, { zIndex: 0 }));
    
      next.classList.add("is-active");
      gsap.set(next, { zIndex: 2, opacity: 1 });
    
      gsap.set(nextImg, {
        clipPath: "inset(0 100% 0 0)",
        opacity: 1,
      });
    
      const mvTl = gsap.timeline({
        defaults: { ease: "power3.inOut" },
        onComplete: () => {
          // prevのスタイルリセット
          prev.classList.remove("is-active");
          gsap.set(prev, { opacity: 0, zIndex: 0 });
          gsap.set(prevImg, { clearProps: "all" });
          gsap.set(nextImg, { clearProps: "clipPath,scale" });
          isAnimating = false;
        },
      });
    
      mvTl.to(nextImg, {
        clipPath: "inset(0 0% 0 0)",
        duration: 1.0,
      })
      .to(
        prevImg,
        {
          opacity: 0.8,
          duration: 1.0,
        },
        "<0.2"
      )
      .to(
        prevImg,
        {
          opacity: 0,
          duration: 0.8,
        },
        "-=0.3"
      )
      .to(
        nextImg,
        {
          duration: 1.4,
        },
        "<"
      );

      if (isLoopToFirst) {
        gsap.set(prevImg, { clipPath: "inset(0 0 0 0)" });
      }
    }
    
    gsap.set(slides[0], { opacity: 1, zIndex: 1 });
    gsap.set(slides[0].querySelector("img"), { clipPath: "inset(0 0 0 0)" });
    
    setInterval(nextSlide, 4000);
    $('.js-acc-item').on('click', function(){
      $(this).toggleClass('is-flipped');
    });

    gsap.registerPlugin(ScrollTrigger);

    const $svg1 = document.querySelector(".js-anime-root01 svg");
    const $svg2 = document.querySelector(".js-anime-root02 svg");
    const $svg3 = document.querySelector(".js-anime-root03 svg");
    const $svg4 = document.querySelector(".js-anime-root04 svg");
    const $svg5 = document.querySelector(".js-anime-root05 svg");
    
    // SP用
    const $svgSp1 = document.querySelector(".js-anime-root01-sp svg");
    const $svgSp2 = document.querySelector(".js-anime-root02-sp svg");
    const $svgSp3 = document.querySelector(".js-anime-root03-sp svg");
    
    [$svg1, $svg2, $svg3, $svg4, $svg5, $svgSp1, $svgSp2, $svgSp3].forEach((svg) => {
      if (svg) svg.style.visibility = "hidden";
    });
    
    if (!isSp) {
      gsap.set(".p-top", { opacity: 0 });
      gsap.set(".js-header", { y: "-100%", opacity: 0 });
      gsap.set(".js-mv-copy", { clipPath: "inset(0 100% 0 0)" });
    
      const tl = gsap.timeline({ delay: 0.5 });
      tl.to(".p-top", { opacity: 1, duration: 0.3, ease: "power1.out" })
        .to(".js-mv-copy", {
          clipPath: "inset(0 0% 0 0)",
          duration: 2.5,
          ease: "power2.out",
        }, "+=0.5")
        .add(() => startRoot01(), "-=2")
        .to(".js-header", {
          y: "0",
          opacity: 1,
          duration: 0.1,
          ease: "power2.out",
        }, "-=2")
    } else {
      gsap.set(".p-top", { opacity: 0 });
      gsap.set(".js-mv-copy", { clipPath: "inset(0 0 0 100%)" });
      gsap.set(".js-header", { opacity: 1 });
    
      const tl = gsap.timeline({ delay: 0.5 });
      tl.to(".p-top", { opacity: 1, duration: 0.3, ease: "power1.out" })
        .to(".js-mv-copy", {
          clipPath: "inset(0 0 0 0%)",
          duration: 0.6,
          ease: "power2.out",
          onComplete: () => startRoot01Sp(),
        });
    }

    // ================================
    // PCアニメーション
    // ================================
    function getAccurateLength(svg, path) {
      const viewBox = svg.viewBox.baseVal;
      const scaleX = svg.clientWidth / viewBox.width;
      const scaleY = svg.clientHeight / viewBox.height;
      const scale = Math.min(scaleX, scaleY);
      return path.getTotalLength() * scale;
    }

    function startRoot01() {
      if ($svg1) {
        const path1 = $svg1.querySelector("path");
        const length1 = getAccurateLength($svg1, path1);
        
        gsap.set(path1, {
          strokeDasharray: length1,
          strokeDashoffset: length1,
          stroke: "#EA6657",
          fill: "none",
        });
        
        gsap.to(path1, {
          strokeDashoffset: 0,
          duration: 2.5,
          ease: "power1.inOut",
          onStart: () => {
            $svg1.style.visibility = "visible";
          },
          onComplete: () => {
            startRoot02();
          },
        });
      }

      function startRoot02() {
        if (!$svg2) return;
        let path2 = $svg2.querySelector("path");
        const length2 = getAccurateLength($svg2, path2);
      
        const ua = window.navigator.userAgent.toLowerCase();
        const isSafari =
          ua.indexOf("safari") !== -1 &&
          ua.indexOf("chrome") === -1 &&
          ua.indexOf("crios") === -1 &&
          ua.indexOf("edg") === -1;
      
        if (isSafari) {
          const reversed = document.createElementNS("http://www.w3.org/2000/svg", "path");
          const steps = 200;
          let d = "";
          for (let i = steps; i >= 0; i--) {
            const p = path2.getPointAtLength((i / steps) * length2);
            d += i === steps ? `M${p.x},${p.y}` : `L${p.x},${p.y}`;
          }
          reversed.setAttribute("d", d);
          reversed.setAttribute("stroke", "#EA6657");
          reversed.setAttribute("stroke-width", path2.getAttribute("stroke-width") || 13);
          reversed.setAttribute("fill", "none");
          path2.parentNode.replaceChild(reversed, path2);
          path2 = reversed;
      
          gsap.set(path2, {
            strokeDasharray: length2,
            strokeDashoffset: length2,
            stroke: "#EA6657",
            fill: "none",
          });
      
          gsap.to(path2, {
            strokeDashoffset: 0,
            duration: 2.5,
            ease: "power1.inOut",
            scrollTrigger: {
              trigger: ".js-area-root01",
              start: "top 20%",
              once: true,
              onEnter: () => {
                $svg2.style.visibility = "visible";
                startRoot03();
              },
            },
          });
        }
      
        else {
          gsap.set(path2, {
            strokeDasharray: length2,
            strokeDashoffset: -length2,
            stroke: "#EA6657",
            fill: "none",
          });
      
          gsap.to(path2, {
            strokeDashoffset: 0,
            duration: 2.5,
            ease: "power1.inOut",
            scrollTrigger: {
              trigger: ".js-area-root01",
              start: "top 20%",
              once: true,
              onEnter: () => {
                $svg2.style.visibility = "visible";
                startRoot03();
              },
            },
          });
        }
      }
      

      function startRoot03() {
        if (!$svg3) return;
        
        const path3 = $svg3.querySelector("path");
        const length3 = getAccurateLength($svg3, path3);
    
        gsap.set(path3, {
          strokeDasharray: length3,
          strokeDashoffset: length3,
          transformOrigin: "center",
          stroke: "white",
          fill: "none",
        });
    
        gsap.to(path3, {
          strokeDashoffset: 0,
          duration: 8,
          ease: "power1.inOut",
          scrollTrigger: {
            trigger: ".js-area-root03",
            start: "top 0%",
            once: true,
            onEnter: () => {
              $svg3.style.visibility = "visible";
              startRoot04();
            },
          },
        });
      }

      function startRoot04() {
        if (!$svg4) return;
        const path4 = $svg4.querySelector("path");
        const length4 = getAccurateLength($svg4, path4);

        gsap.set(path4, {
          strokeDasharray: length4,
          strokeDashoffset: length4,
          transformOrigin: "center",
          stroke: "#EA6657",
          fill: "none",
        });
        
        gsap.to(path4, {
          strokeDashoffset: 0,
          duration: 3,
          ease: "power1.inOut",
          scrollTrigger: {
            trigger: ".js-area-root04",
            start: "top 80%",
            once: true,
            onEnter: () => {
              $svg4.style.visibility = "visible";
            },
            },
            onComplete: () => {
              startRoot05();
            },
        });
      }

      function startRoot05() {
        if (!$svg5) return;
        let path5 = $svg5.querySelector("path");
        const length5 = getAccurateLength($svg5, path5);
      
        const ua = window.navigator.userAgent.toLowerCase();
        const isSafari =
          ua.indexOf("safari") !== -1 &&
          ua.indexOf("chrome") === -1 &&
          ua.indexOf("crios") === -1 &&
          ua.indexOf("edg") === -1;
      
        if (isSafari) {
          const reversed = document.createElementNS("http://www.w3.org/2000/svg", "path");
          const steps = 200;
          let d = "";
          for (let i = steps; i >= 0; i--) {
            const p = path5.getPointAtLength((i / steps) * length5);
            d += i === steps ? `M${p.x},${p.y}` : `L${p.x},${p.y}`;
          }
          reversed.setAttribute("d", d);
          reversed.setAttribute("stroke", path5.getAttribute("stroke") || "url(#paint0_linear_5055_13701)");
          reversed.setAttribute("stroke-width", path5.getAttribute("stroke-width") || 13);
          reversed.setAttribute("fill", "none");
          reversed.setAttribute("vector-effect", "non-scaling-stroke");
          path5.parentNode.replaceChild(reversed, path5);
          path5 = reversed;
      
          gsap.set(path5, {
            strokeDasharray: length5,
            strokeDashoffset: length5,
            transformOrigin: "center",
            fill: "none",
          });
      
          gsap.to(path5, {
            strokeDashoffset: 0,
            duration: 3,
            ease: "power1.inOut",
            scrollTrigger: {
              trigger: ".js-area-root05",
              start: "top 60%",
              once: true,
              onEnter: () => {
                $svg5.style.visibility = "visible";
              },
            },
          });
        }
      
        else {
          gsap.set(path5, {
            strokeDasharray: length5,
            strokeDashoffset: -length5,
            transformOrigin: "center",
            fill: "none",
          });
      
          gsap.to(path5, {
            strokeDashoffset: 0,
            duration: 3,
            ease: "power1.inOut",
            scrollTrigger: {
              trigger: ".js-area-root05",
              start: "top 60%",
              once: true,
              onEnter: () => {
                $svg5.style.visibility = "visible";
              },
            },
          });
        }
      }
    }
    
    // ================================
    // SPアニメーション
    // ================================
    function getAccurateLengthSp(svg, path) {
      const viewBox = svg.viewBox.baseVal;
      const scaleX = svg.clientWidth / viewBox.width;
      const scaleY = svg.clientHeight / viewBox.height;
      const scale = Math.max(scaleX, scaleY);
      return path.getTotalLength() * scale;
    }
    
    function startRoot01Sp() {
      if (!$svgSp1) return;
      const path = $svgSp1.querySelector("path");
      const length = getAccurateLengthSp($svgSp1, path);
    
      gsap.set(path, {
        strokeDasharray: length,
        stroke: "#EA6657",
        fill: "none",
        strokeDashoffset: 0, // まず0に固定（fromToで上書きする）
      });
    
      gsap.fromTo(
        path,
        { strokeDashoffset: length },  // ← 開始（全消し状態）
        {
          strokeDashoffset: 0,         // ← 終了（全表示）
          duration: 2,
          ease: "power1.inOut",
          onStart: () => ($svgSp1.style.visibility = "visible"),
          onComplete: () => activateRoot02Sp(),
        }
      );
    }
    
    function activateRoot02Sp() {
      if (!$svgSp2) return;
      const path = $svgSp2.querySelector("path");
      const length = getAccurateLengthSp($svgSp2, path);
    
      gsap.set(path, {
        strokeDasharray: length,
        stroke: "#EA6657",
        fill: "none",
        strokeDashoffset: 0,
      });
    
      ScrollTrigger.create({
        trigger: ".js-area-root01",
        start: "top 70%",
        once: true,
        onEnter: () => {
          gsap.fromTo(
            path,
            { strokeDashoffset: length },  // ← 全消し
            {
              strokeDashoffset: 0,         // ← 描画方向：正方向
              duration: 2.5,
              ease: "power1.inOut",
              onStart: () => ($svgSp2.style.visibility = "visible"),
              onComplete: () => activateRoot03Sp(),
            }
          );
        },
      });
    }
    
    function activateRoot03Sp() {
      if (!$svgSp3) return;
      const path = $svgSp3.querySelector("path");
      const length = getAccurateLengthSp($svgSp3, path);
    
      gsap.set(path, {
        strokeDasharray: length,
        strokeDashoffset: length,
        stroke: "#EA6657",
        fill: "none",
      });
    
      ScrollTrigger.create({
        trigger: ".js-area-root02",
        start: "top 70%",
        once: true,
        onEnter: () => {
          gsap.to(path, {
            strokeDashoffset: 0,
            duration: 2.5,
            ease: "power1.inOut",
            onStart: () => ($svgSp3.style.visibility = "visible"),
          });
        },
      });
    }
    
    gsap.fromTo(
      ".js-pop-item",
      {
        scale: 0,
        opacity: 0,
        y: 30,
        transformOrigin: "center center"
      },
      {
        scale: 1,
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "back.out(1.2)",
        scrollTrigger: {
          trigger: ".js-pop-area", 
          start: "top 15%",
          once: true,
        }
      }
    );

    $(window).on('scroll', function() {
      const internshipBanner = $('.js-internship-banner');
      
      const scroll = $(window).scrollTop();
      const mvHeight = $('.js-mv').outerHeight();
      const footerTop = $('.js-footer').offset().top;
      const windowHeight = $(window).height();
    
      const $menu = $('.js-fixed-menu');
    
      if (scroll > mvHeight) {
        $menu.addClass('is-active');
        internshipBanner.addClass('is-active');
      } else {
        $menu.removeClass('is-active');
        internshipBanner.removeClass('is-active');
      }
    
      if (scroll + windowHeight > footerTop) {
        $menu.removeClass('is-active');
        internshipBanner.removeClass('is-active');
      }

      function isSp() {
        return window.matchMedia("(max-width: 768px)").matches;
      }
      
      $('.js-internship-banner a').on('click', function (e) {
        if (!isSp()) return;
      
        const banner = $('.js-internship-banner');
      
        if (!banner.hasClass('is-open')) {
          e.preventDefault();
          banner.addClass('is-open');
        }
      });
      
      
      $(window).on('scroll', function () {
        if (!isSp()) return;
      
        const banner = $('.js-internship-banner');
      
        if (banner.hasClass('is-open')) {
          banner.removeClass('is-open');
        }
      });

    });
  }
}

class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.' + this.el).click(function() {
       $(this).next().slideToggle(Number($('html').data('transition')));
       $(this).toggleClass('is-active');
    })
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class Editor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    console.log("aada");
    
    //------- サイドナビ アンカー ---------
    let options = {
      threshold: [0],
      rootMargin: window.matchMedia('(max-width: 768px)').matches
        ? '-60px 0px -60% 0px'
        : '-140px 0px -60% 0px'
    };
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.isIntersecting){
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).siblings().removeClass('is-active')
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).addClass('is-active')
        } else {
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).removeClass('is-active')
        }
      })
    }, options)

    const anchorEl = document.querySelectorAll('[id*="anchor"]')
    anchorEl.forEach((e)=>{
      observerEnter.observe(e)
    })

    
    $('[id*="anchor"]').each(function() {
      let text = $(this).find('.anchorTitle').text();
      let id = $(this).attr('id');
      if(text) {
        let newElement = $(`<a href="#${id}" class="c-transition"><hr class="c-transition">${text}</a>`);
        $('.js-sideNav').append(newElement);
      }
    })

    $(".js-sideNav a").click(function() {
      setTimeout(() => {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
      }, 600)
    })

    $('a[href*="#c-anchor"]').on('click', function(e) {
      const hash = this.hash;
      if (!hash) return;
    
      const target = document.querySelector(hash);
      if (!target) return;
    
      e.preventDefault();
    
      const headerHeight = window.matchMedia('(max-width: 768px)').matches
        ? 60   // SPヘッダー高さ
        : 140; // PCヘッダー高さ
    
      const top =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight;
    
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    
      // URLのhashはちゃんと書き換える
      history.pushState(null, '', hash);
    });
    

    //------- 〆サイドナビ アンカー ---------

    //------- 画像のheught,widthをrem化 ---------
    $('.text-editor img').each(function(index, el) {
      let width = $(el).attr('width')
      // $(el).attr('width')
      $(el).css({'width': `${width * 0.1 + 'rem'}`, 'height': `auto`})
    })
    //------- 画像のheught,widthをrem化 〆 ---------

    //------- アコーディオン ---------
    $('.js-editor-accordion .inner').css({'display': 'none'})

    $('.js-editor-accordion .trigger').on('click', function() {
      $(this).find('.trigger-icon').toggleClass('is-active')
      $(this).next().slideToggle(Number($('html').data('transition')))
    })
    //------- アコーディオン 〆 ---------

    //------- タブ切り替え ---------
    if($(window).innerWidth() >= '769') {

      //------- PCの場合 ---------
      $('.js-tab .inner > div > div:nth-of-type(n + 2)').css({'display': 'none'})
      $('.js-tab .trigger .elementor-element:nth-of-type(1)').addClass('is-active')
  
      $('.js-tab .trigger .elementor-element').on('click', function() {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
        $(this).closest('.js-tab').find('.inner-child').css({'display': 'none'})
        $(this).closest('.js-tab').find('.inner-child').eq($(this).index()).fadeIn(Number($('html').data('transition')))
      })
      //------- PCの場合 〆 ---------

    } else {

      //------- SPの場合 ---------
      $('.js-tab').each(function() {
        const _el = $(this)
        const trigger_child = _el.find('.trigger-child')
        _el.find('.inner-child').each(function(index) {
          $(this).before(trigger_child[index])
        })
      })

      $('<span></span>').appendTo('.trigger-child > div')

      $('.inner-child').css({'display': 'none'})
      $('.trigger-child').click(function() {
        $(this).find('span').toggleClass('is-active')
        $(this).next().slideToggle(Number($('html').data('transition')))
      })
      //------- SPの場合 〆 ---------
      
    }
    //------- タブ切り替え 〆 ---------

    window.addEventListener('load', () => {
      const hash = window.location.hash;
      if (!hash || !hash.startsWith('#c-anchor')) return;
    
      const target = document.querySelector(hash);
      if (!target) return;
    
      const headerHeight = window.matchMedia('(max-width: 768px)').matches
        ? 60
        : 140;
    
      const top =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight;
    
      setTimeout(() => {
        window.scrollTo({
          top,
          behavior: 'auto'
        });
      }, 50);
    });
  }
}
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class HeaderMenu {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    var windowWidth = $(window).width();
    var windowSm = 768;
    if (windowWidth <= windowSm) {
      $('.js-h-content a').on('click', function() {
        $('html').removeClass('is-open');
        scrollBan();
      });
      $('.js-mega-trigger').on('click', function() {
        $(this).toggleClass('is-active');
        $(this).find('.js-mega-plus').toggleClass('is-active');
        $(this).children('.js-mega-content').slideToggle();
      });
    } else {
      $('.js-mega-trigger').hover(function() {
        $(this).addClass('is-active');
        $(this).children('.js-mega-content').addClass('is-active');
      }, function() {
        $(this).removeClass('is-active'); 
        $(this).children('.js-mega-content').removeClass('is-active');
      });

      $('.js-mega-content').hover(function() {
        $(this).addClass('is-active');
        $(this).parent('.js-mega-trigger').addClass('is-active');
      }, function() {
        $(this).removeClass('is-active');
        $(this).parent('.js-mega-trigger').removeClass('is-active');
      });
    }
    
    $(window).scroll(function () {
      if ($(window).scrollTop() > 20) {
        $('html').addClass('is-scroll');
      } else {
        if (!$('html').hasClass('is-open')) {
          $('html').removeClass('is-scroll');
        }
      }
    });
    
    $('.js-drawer').click(function () {
      $('html').toggleClass('is-open');
      scrollBan();
    });

    let scrollTop = 0;

    function scrollBan() {
      const body = $('html')[0];
      if (body.classList.contains('is-hidden')) {
        body.style.scrollBehavior = 'auto';
        body.style.top = '';
        body.classList.remove('is-hidden');
        window.scrollTo(0, scrollTop);
        setTimeout(() => body.style.scrollBehavior = 'smooth', 0);
      } else {
        scrollTop = window.scrollY;
        body.style.top = (scrollTop * -1) + 'px';
        body.classList.add('is-hidden');
      }
    }
  }
}
// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class Modal {
  constructor(el,opt){
    this.el = el;
    this.event();
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).on('click', function(e) {
      e.preventDefault();
      $(`[data-id='${$(this).attr('id')}']`).addClass('is-active');
      scrollBanOpen();
    })

    $("." + this.el + "-close").on('click', function() {
      $('.js-modal-container').removeClass('is-active');
      scrollBanClase();
    })
  }
}
// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBanOpen() {
  const body = $('html')[0];
  // スクロール禁止
  scrollTop = window.scrollY;
  body.style.top = (scrollTop * -1) + 'px';
  body.classList.add('is-hidden');
}

function scrollBanClase() {
  const body = $('html')[0];
  // スクロール開放
  body.style.top = '';
  body.classList.remove('is-hidden');
  window.scrollTo(0, scrollTop);
}
// Safari 判定関数（どのクラスやイベントよりも先頭に置く）

window.addEventListener('load', () => {
  setTimeout(() => {
    $('.js-loading').fadeOut();
  }, 1500);
  if ($('html').hasClass('is-top')) {
    new Top('p-top');
  }
});


(() => {

  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let headerMenu = new HeaderMenu('js-header');
  // ------------------------------
  // トップページ用
  // ------------------------------
  
  // ------------------------------
  // ページビルダー用
  // ------------------------------
  let modal = new Modal('js-modal');
  let accordion = new Accordion('js-accordion');
  let editor = new Editor('c-content');
  let editorGuide = new Editor('js-guide');
  let guide = new Guide('js-guide');
  let interview = new Interview('js-swiper-interview');

  $(document).ready(function () {
    new ScrollHint('.js-scrollable',{
      scrollHintIconAppendClass: 'scroll-hint-icon-white',
      i18n: {
        scrollable: "スクロールできます"
      }
    });
  });
})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
});